import React from 'react';

interface DisclaimerColumnProps {
  title: string;
  children: React.ReactNode;
  width?: string;
}

export const DisclaimerColumn: React.FC<DisclaimerColumnProps> = ({ 
  title, 
  children, 
  width = 'flex-1' 
}) => {
  return (
    <div className={width}>
      <span className="text-[#888883] text-[15px] font-bold leading-[21px] tracking-[0.15px]">
        {title}
        <br /><br />
      </span>
      <span className="text-[#888883] text-[15px] font-normal leading-[21px] tracking-[0.15px]">
        {children}
      </span>
    </div>
  );
};
